// extracted by mini-css-extract-plugin
export var logo = "_j5-2";
export var logoWrapper = "_j5-1";
export var strip = "_j5-0";